//@flow
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Modal from '../../../../../../elements/Modal/Modal';

import shippingeBay from '../../../../../../assets/img/new-order/modal/shippingeBay.jpg';

import style from './EbayInformationModal.scss';
import buttonStyle from '../../../../../../assets/styles/button.scss';

export type ErrorType = 'ebayAuction' | 'notCartUrlFormat' | 'amazonSpain';

type Props = {
  isOpen?: boolean;
  handleClose: () => void;
};

export default function EbayInformationModal(props: Props) {
  const { isOpen, handleClose } = props;

  const bodyContent = 
    <div className={style.textContent}>
      <span>
        Ten en cuenta que si el vendedor no hace envíos a USA,
        no podremos enviar tu pedido. Revisa en las especificaciones
        de la publicación de eBay si hace envíos dentro de Estados 
        Unidos. Puedes simular el envío utilizando el Zip Code: 33185
      </span>
      <br />
      <span className={style.textCenter}>Ejemplo:</span>

    </div>;

  const titleContent =
    <p className={style.title}>Revisa que el vendedor de eBay haga envíos a Estados Unidos</p>;

  return (
    <Modal
      key='ebayInformationModal'
      open={isOpen}
      width={450}
      height={350}
      handleClose={() => handleClose()}
    >
      <div className={style.topWrap}>
        <div className={style.textWrap}>{titleContent}</div>
      </div>
      <div className={style.contentWrap}>
        {bodyContent}
        <hr className={style.horizontalLine} />
        <img src={shippingeBay} alt="shippingeBay"/>
        <div className={classNames(buttonStyle.btn, style.buttonWrap)}>
          <button onClick={() => handleClose()}>Continuar</button>
        </div>
      </div>
    </Modal>
  );
}

EbayInformationModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/EbayInformationModal/EbayInformationModal.jsx